import React from 'react';
import css from './Spinner.module.css';
import clsx from 'clsx';
import { SpinnerSize } from './SpinnerSize';

interface SpinnerProps {
  size?: SpinnerSize;
}

const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => {
  const { size = SpinnerSize.Normal } = props;
  const sizeStyle = (): string => {
    switch (size) {
      case SpinnerSize.Small:
        return css.small;
      case SpinnerSize.Inline:
        return css.inline;
      case SpinnerSize.Normal:
      default:
        return css.normal;
    }
  };

  return <span className={clsx(css.circle, sizeStyle())}></span>;
};

export default Spinner;
